// extracted by mini-css-extract-plugin
export var divider = "_va-0";